export default __webpack_public_path__ + "static/media/Stop.a287afb8.svg";